import './index-57001be3.js';
import { L as LOCALE } from './Locale-e37edea6.js';

const siteHost = {
    HELLO_HEALTH_GROUP: 'hellohealthgroup.com',
    HELLO_DOCTOR: 'hellodoctor.com.ph',
    HELLO_DOCTOR_FIL: 'hellodoctor.com.ph/fil',
    HELLO_KRUPET: 'hellokrupet.com',
    HELLO_SWASTHYA: 'helloswasthya.com',
    HELLO_SEHAT: 'hellosehat.com',
    HELLO_SAYARWON: 'hellosayarwon.com',
    HELLO_DOKTOR: 'hellodoktor.com',
    HELLO_KHUNMOR: 'hellokhunmor.com',
    HELLO_YISHI: 'helloyishi.com.tw',
    HELLO_BACSI: 'hellobacsi.com',
    MARRY_BABY: 'www.marrybaby.vn',
};
const siteOptions = {
    HELLO_HEALTH_GROUP: {
        lng: LOCALE.PhilippinesEnglish,
        ns: 'translation',
        name: 'Hello Health Group',
        theme: 'hellosite',
        dayjs: 'en',
        phoneCountry: 'PH',
        siteId: 10,
    },
    HELLO_DOCTOR: {
        lng: LOCALE.PhilippinesEnglish,
        ns: 'translation',
        name: 'Hello Doctor',
        theme: 'hellosite',
        dayjs: 'en',
        phoneCountry: 'PH',
        siteId: 5,
    },
    HELLO_DOCTOR_FIL: {
        lng: LOCALE.PhilippinesTagalog,
        ns: 'translation',
        name: 'Hello Doctor',
        theme: 'hellosite',
        dayjs: 'tl-ph',
        phoneCountry: 'PH',
        siteId: 5,
    },
    HELLO_KRUPET: {
        lng: LOCALE.Cambodia,
        ns: 'translation',
        name: 'Hello Krupet',
        theme: 'hellosite',
        dayjs: 'km',
        phoneCountry: 'KH',
        siteId: 4,
    },
    HELLO_SWASTHYA: {
        lng: LOCALE.India,
        ns: 'translation',
        name: 'Hello Swasthya',
        theme: 'hellosite',
        dayjs: 'hi',
        phoneCountry: 'IN',
        siteId: 9,
    },
    HELLO_SEHAT: {
        lng: LOCALE.Indonesia,
        ns: 'translation',
        name: 'Hello Sehat',
        theme: 'hellosite',
        dayjs: 'id',
        phoneCountry: 'ID',
        siteId: 2,
    },
    HELLO_SAYARWON: {
        lng: LOCALE.Myanmar,
        ns: 'translation',
        name: 'Hello Sayarwon',
        theme: 'hellosite',
        dayjs: 'my',
        phoneCountry: 'MM',
        siteId: 7,
    },
    HELLO_DOKTOR: {
        lng: LOCALE.Malaysia,
        ns: 'translation',
        name: 'Hello Doktor',
        theme: 'hellosite',
        dayjs: 'ms-my',
        phoneCountry: 'MY',
        siteId: 3,
    },
    HELLO_KHUNMOR: {
        lng: LOCALE.Thailand,
        ns: 'translation',
        name: 'Hello Khunmor',
        theme: 'hellosite',
        dayjs: 'th',
        phoneCountry: 'TH',
        siteId: 6,
    },
    HELLO_YISHI: {
        lng: LOCALE.Taiwan,
        ns: 'translation',
        name: 'Hello Yishi',
        theme: 'hellosite',
        dayjs: 'zh-tw',
        phoneCountry: 'TW',
        siteId: 8,
    },
    HELLO_BACSI: {
        lng: LOCALE.Vietnam,
        ns: 'translation',
        name: 'Hello Bacsi',
        theme: 'hellosite',
        dayjs: 'vi',
        phoneCountry: 'VN',
        siteId: 1,
    },
    MARRY_BABY: {
        lng: LOCALE.Vietnam,
        ns: 'marrybaby',
        name: 'Marry Baby',
        theme: 'marrybaby',
        dayjs: 'vi',
        phoneCountry: 'VN',
        siteId: 11,
    },
};

export { siteHost, siteOptions };
